const bytesInKb = 1024;
const bytesInMb = 1024 * 1024;
const bytesInGb = 1024 * 1024 * 1024;

const obj = {
    spaceChar: "\u00A0",
    priceChar: "₽",

    capitalize(str) {
        return str.toString().charAt(0).toUpperCase() + str.toString().slice(1);
    },

    fromatPhone(number) {
        if (!number)
            return "";

        number = number.replace("+", "");
        return `+${number.slice(0, 1)} ${number.slice(1, 4)} ${number.slice(4, 7)} ${number.slice(7, 9)} ${number.slice(9)}`;
    },

    formatFullName(info, type) {
        const { fname, lname, sname } = info || {};
        const names = [];

        if (type === "short") {
            const name = fname ? (fname[0] + ".") : "";
            const otc = sname ? (sname[0] + ".") : "";

            if (lname)
                names.push(lname);

            if (name && otc)
                names.push(name + otc);
            else {
                if (name)
                    names.push(name);
                if (otc)
                    names.push(otc);
            }
        }
        else {
            if (lname)
                names.push(lname);
            if (fname)
                names.push(fname);
            if (sname)
                names.push(sname);
        }

        return names.join(" ");
    },

    formatFileSize(bytes) {
        if (bytes < bytesInKb)
            return bytes + ' B';
        if (bytes < bytesInMb)
            return (bytes / bytesInKb).toFixed(2) + ' KB';
        if (bytes < bytesInGb)
            return (bytes / bytesInMb).toFixed(2) + ' MB';

        return (bytes / bytesInGb).toFixed(2) + ' GB';
    },

    getNumberText(number, one, two, five) {
        let n = Math.abs(number);
        n %= 100;

        if (n >= 5 && n <= 20)
            return five;

        n %= 10;
        if (n === 1)
            return one;

        if (n >= 2 && n <= 4)
            return two;

        return five;
    },

    isJSONString(str) {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    },

    normalize(text) {
        return text
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .trim();
    },

    levenshtein(a, b) {
        const m = a.length;
        const n = b.length;
        const dp = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));

        for (let i = 0; i <= m; i++) dp[i][0] = i;
        for (let j = 0; j <= n; j++) dp[0][j] = j;

        for (let i = 1; i <= m; i++) {
            for (let j = 1; j <= n; j++) {
                const cost = a[i - 1] === b[j - 1] ? 0 : 1;
                dp[i][j] = Math.min(
                    dp[i - 1][j] + 1,
                    dp[i][j - 1] + 1,
                    dp[i - 1][j - 1] + cost
                );
            }
        }

        return dp[m][n];
    },

    isSimilar(a, b) {
        const maxLen = Math.max(a.length, b.length);
        const distance = obj.levenshtein(a, b);
        const similarity = 1 - distance / maxLen;
        return similarity >= 0.9;
    }
};

export default obj;
